$(() => {
  const confirmButton = () => {
    if ($('#inquiry_agreement').is(':checked')) {
      $('#js-confirm').removeClass('disable');
      return $('#js-confirm input').prop('disabled', false);
    } else {
      $('#js-confirm').addClass('disable');
      return $('#js-confirm input').prop('disabled', true);
    }
  };
  confirmButton();
  $('#inquiry_agreement').on('change', () => {
    return confirmButton();
  });

  const initForm = () => {
    $('#inquiry_warning').hide();
    $('#inquiry_form').hide();
  };
  const showError = () => {
    $('#inquiry_warning').show();
    $('#inquiry_form').hide();
  };
  const showForm = () => {
    $('#inquiry_warning').show();
    $('#inquiry_form').show();
  };

  $('#inquiry_type').change(() => {
    var val = $('option:selected').val();
    if (!val) {
      initForm();
    } else if (val === 'pet') {
      showForm();
    } else if (val === 'hospital') {
      showError();
    }
  });

  const isValidationError = () => {
    return window.location.pathname === '/inquiry' || $('p').hasClass('textStyleAlert');
  };

  if (isValidationError()) {
    showForm();
  }
});
